import { render, staticRenderFns } from "./SectorsSelector.vue?vue&type=template&id=5ec6fdac&scoped=true"
import script from "./SectorsSelector.vue?vue&type=script&lang=js"
export * from "./SectorsSelector.vue?vue&type=script&lang=js"
import style0 from "./SectorsSelector.vue?vue&type=style&index=0&id=5ec6fdac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec6fdac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec6fdac')) {
      api.createRecord('5ec6fdac', component.options)
    } else {
      api.reload('5ec6fdac', component.options)
    }
    module.hot.accept("./SectorsSelector.vue?vue&type=template&id=5ec6fdac&scoped=true", function () {
      api.rerender('5ec6fdac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/form/SectorsSelector.vue"
export default component.exports